import { useParams } from "@tanstack/react-router";
import { OverheadCategoryDetail } from "@/components/admin/OverheadCategoryDetail";
import { useSession } from "@/lib/auth-client";

export function OverheadCategoryDetailPage() {
  const { categoryId } = useParams({ from: "/dashboard/overhead-categories/$categoryId" });
  const { data: session } = useSession();
  const isAdmin = session?.user?.role === "ops";

  return <OverheadCategoryDetail categoryId={categoryId} isAdmin={isAdmin} />;
}
